// extracted by mini-css-extract-plugin
export default {"cardListSkeleton":"cardListSkeleton_cardListSkeleton__SDlFy","skeleton":"cardListSkeleton_skeleton__J-Jtp","skeleton-animation":"cardListSkeleton_skeleton-animation__+8tC9"};